import React from 'react'
import { TextStyle, TouchableOpacity, View, ViewStyle, FlatList } from 'react-native'
import { color } from '../../theme'
import { iconClose } from '../../assets'
import { SvgIcon } from '../svg-icon'
import { Text } from '../text'
import { Dialog } from '@mui/material'
import { Medal } from '../medal'
import { Instance } from 'mobx-state-tree'
import { UserMedal } from '@trivie/core/src/models/UserCertificationMedal'
import LinearGradient from 'react-native-linear-gradient'

interface MedalModalProps {
  visible: boolean
  onClose: () => void
  level: string
  items: Array<Instance<typeof UserMedal>>
}
export const MedalModal = (props: MedalModalProps) => {
  const { visible, level, onClose, items } = props
  const renderLabelColor = () => {
    switch (level) {
      case 'Gold':
        return { background: '#ffffff', text: '#EDB552', gradient: 'rgba(237, 181, 82, 0.15)' }
      case 'Silver':
        return { background: '#ffffff', text: '#778390', gradient: 'rgba(113, 116, 132, 0.15)' }
      case 'Bronze':
        return { background: '#ffffff', text: '#A59E8E', gradient: 'rgba(170, 144, 131, 0.15)' }
      default:
        return { background: '#ffffff', text: '#000000', gradient: '#000000' }
    }
  }
  return (
    <Dialog aria-labelledby="confirmation-dialog-title" open={visible} style={ROOT}>
      <View style={CONTAINER}>
        <View style={HEADER}>
          <Text style={TITLE} variant="headline" text={`${level} Medals`} />
          <div style={{ flex: 0.3 }} />
          <TouchableOpacity
            // @ts-ignore
            dataSet={{ qat: 'close_btn' }}
            onPress={onClose}
            style={CLOSE_BUTTON}
          >
            <SvgIcon src={iconClose} color={color.black} size={24} />
          </TouchableOpacity>
        </View>
        <LinearGradient
          useAngle
          angle={180}
          locations={[0, 1]}
          start={{ x: 0, y: 0 }}
          end={{ x: 1, y: 0 }}
          colors={[renderLabelColor().gradient, renderLabelColor().gradient]}
          style={COUNT_STYLE}
        >
          <Text
            style={{ ...COUNT_TEXT, color: renderLabelColor().text }}
            text={`${items?.length}`}
          />
        </LinearGradient>
        <View style={CONTENT}>
          <FlatList
            data={items}
            contentContainerStyle={LIST_CONTAINER}
            style={{ width: '100%' }}
            renderItem={({ item }) => {
              return (
                <View
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    paddingBottom: 10,
                  }}
                >
                  <Medal style={{ alignSelf: 'center' }} level={level} recall={null} size={32} />
                  <Text
                    style={{ textAlign: 'center', paddingLeft: 5 }}
                    variant="body2Medium"
                    text={`${item.title}`}
                  />
                </View>
              )
            }}
          />
        </View>
      </View>
    </Dialog>
  )
}

/**
 * Styling
 */
const ROOT: React.CSSProperties = {
  flex: 1,
  backgroundColor: color.shade20,
  flexDirection: 'column',
}
const CONTAINER: ViewStyle = {
  height: 501,
  minWidth: 300,
  borderRadius: 20,
  margin: 20,
  backgroundColor: color.white,
  borderBottomLeftRadius: 20,
  borderBottomRightRadius: 20,
}
const HEADER: ViewStyle = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  alignItems: 'flex-end',
}
const TITLE: TextStyle = {
  alignSelf: 'center',
  color: color.black,
  textAlign: 'center',
  marginBottom: 20,
}
const CLOSE_BUTTON: ViewStyle = {
  borderRadius: 100,
  width: 42,
  height: 42,
  backgroundColor: color.shade04,
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: 15,
  marginLeft: 12,
}
const CONTENT: ViewStyle = {
  flex: 1,
  justifyContent: 'space-evenly',
  alignItems: 'center',
}
const LIST_CONTAINER: ViewStyle = {
  paddingBottom: 12,
  marginBottom: 6,
}
const COUNT_STYLE: ViewStyle = {
  height: 25,
  minWidth: 40,
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  alignSelf: 'center',
  borderRadius: 10,
  marginBottom: 12,
}

const COUNT_TEXT: TextStyle = {
  fontWeight: '700',
  fontSize: 12,
  color: '#EAB021',
}
